import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule, PageSlotModule } from '@spartacus/storefront';
import { ChatMenuMobileComponent } from './chat-menu-mobile.component';

@NgModule({
  imports: [NgIf, AsyncPipe, IconModule, PageSlotModule],
  declarations: [ChatMenuMobileComponent],
  exports: [ChatMenuMobileComponent],
})
export class ChatMenuMobileModule {}
